import type { Messages } from "./en";

// Simplified Chinese.
export const zh: Messages = {
  "nav.home": "LEARNABLE 首页",
  "nav.main": "主导航",
  "nav.courses": "课程",
  "nav.review": "复习",
  "nav.progress": "进度",
  "nav.guide": "指南",
  "nav.marketplace": "课程市场",
  "nav.streak": "连续学习天数：{n}",
  "nav.xp": "总经验值：{n} XP",

  "account.menu": "账户",
  "account.settings": "设置",
  "account.guide": "LEARNABLE 使用说明",
  "account.signOut": "退出登录",

  "common.save": "保存",
  "common.saved": "已保存。",
  "common.saving": "正在保存…",
  "common.cancel": "取消",
  "common.close": "关闭",
  "common.pleaseWait": "请稍候…",

  "signin.title": "登录 LEARNABLE",
  "signin.registerTitle": "创建账户",
  "signin.email": "电子邮箱",
  "signin.password": "密码",
  "signin.passwordRule": "至少 12 个字符。",
  "signin.submit": "登录",
  "signin.register": "创建账户",
  "signin.forgot": "忘记密码？",
  "signin.toRegister": "创建新账户",
  "signin.toSignIn": "我已有账户",
  "signin.language": "语言",

  "password.current": "当前密码",
  "password.new": "新密码（至少 12 个字符）",
  "password.change": "修改密码",
  "password.changed": "密码已修改。你的其他设备已退出登录。",

  "settings.title": "设置",
  "settings.intro": "你的个人资料和偏好设置。它们保存在你的账户中，在所有设备上生效。",
  "settings.profile": "个人资料",
  "settings.displayName": "显示名称",
  "signin.emailOrUsername": "邮箱或用户名",
  "signin.username": "用户名(可选)",
  "signin.usernameHint": "3–30 个字母、数字、点、下划线或连字符。可用它代替邮箱登录。",
  "settings.username": "用户名",
  "settings.usernameHint": "可选。可用此名称代替邮箱登录,其他人看不到。留空即可移除。",
  "settings.displayNameHint": "代替你的电子邮箱显示。留空则使用电子邮箱。",
  "settings.email": "电子邮箱",
  "settings.emailHint": "你用来登录的地址。",
  "settings.language": "语言",
  "settings.languageHint": "菜单和页面使用的语言。课程资料和 AI 的反馈仍使用课程本身的语言。",
  "settings.translationNote": "翻译仍在进行中：部分页面暂时仍为英文。",
  "settings.study": "学习",
  "settings.timezone": "时区",
  "settings.timezoneHint": "你的学习日、连续学习天数和每日目标都按此时区计算。",
  "settings.dailyGoal": "每日目标",
  "settings.dailyGoalHint": "每天回答的题数。",
  "settings.security": "安全",
  "settings.signOutHint": "退出登录会从此浏览器中清除你账户的数据。",

  "guide.title": "LEARNABLE 使用说明",
  "guide.intro": "LEARNABLE 把你自己的学习资料变成问题，检查你的回答，并在你快要忘记之前安排每一次复习。",
  "guide.contents": "目录",
  "guide.structure.title": "1. 课程的结构",
  "guide.structure.body": "一门课程分为若干章节，章节分为主题，主题分为概念。每个概念包含学习条目：需要记住的知识点，每个知识点通过一个或多个问题来提问。",
  "guide.material.title": "2. 添加学习资料",
  "guide.material.body": "打开一门课程，上传 PDF、Word、PowerPoint、文本或 Markdown 文件，或直接粘贴文本。如果你已经有问答，请用以 \"Question:\" 和 \"Answer:\"（或 \"Domanda:\" 和 \"Risposta:\"）开头的行上传：每一组都会成为一个概念，不使用 AI。",
  "guide.curriculum.title": "3. 生成课程大纲",
  "guide.curriculum.body": "让 AI 根据你的资料提出章节、主题和概念。检查提案，重命名、移动或删除任何内容，然后接受。在你接受之前不会有任何改动。",
  "guide.study.title": "4. 学习一个概念",
  "guide.study.body": "打开一个概念并点击“激活”:学习条目会根据你的资料生成。读完后点击“我已学完这个概念”。每个问题会一直重复,直到你答对三次(不必连续),每次回答后都有反馈。",
  "guide.answer.title": "5. 作答并获得反馈",
  "guide.answer.body": "用你自己的话写下答案，或点击 \"口述你的回答\" 进行语音输入。可以使用提示，但经验值会减半。AI 判断的是意思而不是字面，并显示四项评分以及正确、遗漏和错误之处的清单。参考答案及其出处随时一键可见。",
  "guide.disagree.title": "6. 如果你不同意评分",
  "guide.disagree.body": "点击 \"Disagree with the grade?\"。你可以说明理由并请 AI 再评一次（两次结果都会保留显示），也可以自己给答案评分。你自己的评分始终优先。",
  "guide.review.title": "7. 按时复习",
  "guide.review.body": "每次作答都会把该问题排进复习计划：掌握得越好，下次出现的时间越晚。复习页面和你的主页会显示到期的内容以及大约需要多少时间。",
  "guide.progress.title": "8. 跟踪你的进度",
  "guide.progress.body": "连续学习天数记录你学习的日子，经验值奖励正确答案，每日目标帮你掌握节奏。\"你总是答错的内容\" 汇总了你最近回答中发现的错误，并提供练习按钮。",
  "guide.organise.title": "9. 保持整洁",
  "guide.organise.body": "在 \"管理题目\" 中，你可以选择单个问题，或整个章节、主题和概念，进行删除、暂停、恢复或移动；也可以编辑问题，并拖动 ⠿ 调整顺序。较长的部分可以通过标题旁的箭头折叠。",
  "guide.marketplace.title": "10. 分享与获取课程",
  "guide.marketplace.body": "在课程市场中，你可以按类别、难度、语言和规模查找其他用户创建的课程。添加之前，你能看到课程页面：涵盖内容、适合人群、你将学到什么、章节以及题目数量。点击 \"添加到我的课程\" 后，课程会出现在你的仪表板上：作者负责更新题目，你不能编辑，但学习是你自己的（你的计划、答案、经验值，以及你给每道题设定的优先级）。作者的资料无法下载。要分享你自己的课程，打开它并撰写 \"课程市场页面\"，先保存为草稿，然后发布。",
  "guide.glossary.title": "应用中的术语",
  "guide.term.concept": "概念",
  "guide.term.concept.def": "课程中的一个知识点，例如一个定义或一条规则。",
  "guide.term.item": "学习条目",
  "guide.term.item.def": "概念中需要记住的一条内容，带有问题和标准答案。",
  "guide.term.active": "Active（已激活）",
  "guide.term.active.def": "该概念参与学习和复习。已暂停或未学习的概念不参与。",
  "guide.term.grades": "重来 · 困难 · 良好 · 简单",
  "guide.term.grades.def": "重来、困难、良好、简单：表示你对答案的掌握程度，决定问题何时再次出现。",
  "guide.term.mastery": "掌握度",
  "guide.term.mastery.def": "根据你的复习记录估算你对某个概念的记忆程度。",
  "guide.term.xp": "经验值和连续天数",
  "guide.term.xp.def": "正确作答获得的分数，以及你连续学习的天数。",
  "guide.privacy.title": "你的数据",
  "guide.privacy.body": "你的课程、答案和进度只有你自己能看到。语音输入由浏览器转写，只保存文字。",
  "help.button": "帮助：{topic}",
  "help.more": "了解更多",
  "help.nextStep": "现在最有用的一件事。到期的复习总是排在最前，然后才是新内容。",
  "help.courses": "每门课程一张卡片。绿色按钮复习到期的内容，蓝色按钮继续学习新内容。",
  "help.streak": "连续至少回答一题的天数。今天回答一题即可保持。",
  "help.xp": "经验值，通过正确回答获得。使用提示会减半。",
  "help.goal": "你每天想回答的题数。可以在设置中修改。",
  "help.planner": "每个时间点前到期的问题数量，以及大约需要多少时间。",
  "help.coursePlanner": "仅限此课程:各问题何时到期、大约需要多长时间。新内容每题至少需要答对三次。",
  "help.activity": "每个方块代表一天：颜色越深，回答越多。",
  "help.concept": "概念是课程中的一个知识点。开始学习它以准备问题，阅读它的学习条目，然后进行练习。",
  "help.consolidate": "读完下方学习条目后点击按钮。每个问题会一直重复,直到你答对三次,这样才能记牢。",
  "help.study": "用自己的话写出答案或口述。AI 判断意思而非字面，并显示正确和遗漏之处。",
  "help.questions": "勾选单个问题或整个章节、主题、概念，然后删除、暂停或移动它们。拖动 ⠿ 调整顺序。",
  "help.marketplace": "其他用户创建的课程。打开一个课程，查看它涵盖的内容和题目数量；添加后即可按你自己的计划学习。作者会持续更新。",
  "help.weakSpots": "你最近回答中发现的错误，按概念分组。反复练习，直到它们从列表中消失。",
  "help.material": "上传 PDF、Word、PowerPoint 或文本文件，或粘贴文本。LEARNABLE 会据此生成课程和问题。",
  "start.title": "LEARNABLE 使用说明",
  "start.intro": "四个步骤。打开任意一步可在指南中查看。",
  "start.hide": "知道了，隐藏",
  "start.reopen": "查看 LEARNABLE 使用说明",
  "start.material.title": "添加资料",
  "start.material.body": "创建课程并上传笔记、幻灯片或书籍，或粘贴文本。",
  "start.plan.title": "确认学习计划",
  "start.plan.body": "AI 提出章节和概念。随意修改后接受。",
  "start.study.title": "学习并作答",
  "start.study.body": "阅读一个概念，然后用自己的话或语音回答它的问题。",
  "start.review.title": "按时复习",
  "start.review.body": "问题会在你快忘记之前再次出现。跟着绿色按钮走。",
  "nav.community": "社区",
  "community.title": "社区",
  "community.intro": "看看谁获得的经验最多，关注其他学习者并为他们加油。",
  "community.tab.leaderboard": "排行榜",
  "community.tab.friends": "好友",
  "community.period": "时间范围",
  "community.scope": "范围",
  "community.period.day": "今天",
  "community.period.week": "本周",
  "community.period.month": "本月",
  "community.period.all": "全部时间",
  "community.scope.everyone": "所有人",
  "community.scope.friends": "好友",
  "community.leader": "领先者",
  "community.xp": "{n} 经验值",
  "community.you": "你",
  "community.yourPlace": "你的名次",
  "community.empty": "这段时间还没有人获得经验值。",
  "community.emptyFriends": "关注其他学习者，就能在这里与他们比较。",
  "community.windowNote": "日期按 UTC 时间计算；每周从周一开始。只显示加入社区的人。",
  "community.joinTitle": "加入社区",
  "community.joinText": "你还不在排行榜上。开启社区可见性后，你会出现在榜单上，并能被他人找到和关注。其他人只能看到你的显示名称和经验值，永远看不到你的邮箱。",
  "community.joinButton": "在社区中显示我",
  "community.needName": "请先在设置中选择一个显示名称。",
  "community.follow": "关注",
  "community.following": "已关注",
  "community.friend": "好友",
  "community.followsYou": "关注了你",
  "community.since": "自 {date} 起在此学习",
  "community.statXpTotal": "总经验值",
  "community.statXpWeek": "本周经验值",
  "community.statStreak": "连续天数",
  "community.statFollowers": "粉丝",
  "community.statFollowing": "关注中",
  "community.followingList": "你关注的人",
  "community.followersList": "你的粉丝",
  "community.searchLabel": "按名称查找学习者",
  "community.searchPlaceholder": "按显示名称搜索",
  "community.search": "搜索",
  "community.noResults": "没有找到任何人。只能找到已加入社区的人。",
  "community.noFollowing": "你还没有关注任何人。",
  "community.noFollowers": "还没有粉丝。",
  "community.streakDays": "连续 {n} 天",
  "community.xpToday": "今天 {n} 经验值",
  "community.notFound": "该资料不可用。",
  "community.seeLeaderboard": "查看社区排行榜",
  "course.leaderboardLink": "课程排行榜",
  "course.leaderboardTitle": "课程排行榜",
  "course.leaderboardIntro": "所有拥有该课程的人在此课程中获得的经验值。",
  "course.leaderboardPrivate": "这是私人课程，所以排行榜上只有你一个人。来自课程市场的课程会与所有拥有它的人共享榜单。",
  "course.leaderboardParticipants": "{n} 位学习者共享此课程。",
  "settings.community": "社区",
  "settings.communityToggle": "在社区中显示我（排行榜、搜索和关注）",
  "settings.communityHint": "默认关闭。其他人只能看到你的显示名称、经验值和连续天数，看不到你的邮箱、课程或答案。开启前需要先设置显示名称。",
  "study.repeat.badge": "快对了：再写一遍",
  "study.repeat.title": "先看参考答案，再重新写一遍",
  "study.repeat.body": "你的回答在大多数要点上都很扎实。请阅读上方的参考答案,再用自己的话重新写一遍。若复述得好,就算答对,进度向前推进;否则该项回到第 0 级。",
  "study.repeat.label": "再次写出你的回答",
  "study.repeat.submit": "提交重写",
  "study.repeat.selfGrade": "改为自己打分",
  "study.repeat.evalTitle": "你的复述",
  "error.generic": "出了点问题，请重试。",
  "error.transport": "无法连接服务器。请检查网络后重试。",
  "error.session": "登录已过期，请重新登录。",
  "error.validation": "输入的部分信息无效。",
  "error.notFound": "该项目已不存在。",
  "error.tooLarge": "文件太大。",
  "error.unsupported": "不支持该文件类型。请使用 PDF、Word、PowerPoint、文本或 Markdown 文件。",
  "error.aiNotConfigured": "服务器尚未设置 AI。",
  "error.aiUnavailable": "AI 暂时不可用，请稍后再试。",
  "error.aiInvalid": "AI 给出了无法使用的回复，请重试。",
  "error.state": "当前状态下无法执行该操作。",
  "error.server": "服务器出了点问题，请重试。",
  "error.rateLimited": "尝试次数过多，请稍等片刻后重试。",
  "error.managedCourse": "该课程来自课程市场：作者会持续更新，因此无法在此修改其内容。",
  "studyState.NOT_STUDIED": "未学习",
  "studyState.STUDIED": "已学习",
  "studyState.ACTIVE": "进行中",
  "studyState.PAUSED": "已暂停",
  "studyState.COMPLETED": "已完成",
  "memoryState.NEW": "新",
  "memoryState.LEARNING": "学习中",
  "memoryState.REVIEW": "复习中",
  "memoryState.RELEARNING": "重新学习",
  "memoryState.MASTERED": "已掌握",
  "outcome.AGAIN": "重来",
  "outcome.HARD": "困难",
  "outcome.GOOD": "良好",
  "outcome.EASY": "简单",
  "outcomeHelp.AGAIN": "我不知道",
  "outcomeHelp.HARD": "我知道，但很吃力",
  "outcomeHelp.GOOD": "我知道",
  "outcomeHelp.EASY": "我轻松就知道",
  "classification.CORRECT": "正确",
  "classification.PARTIALLY_CORRECT": "部分正确",
  "classification.MISCONCEPTION": "概念错误",
  "classification.WRONG": "不正确",
  "classification.UNCERTAIN": "不确定",
  "role.CORE_TRAINABLE": "核心",
  "role.SUPPORTING_TRAINABLE": "辅助",
  "role.COMMON_TRAP": "常见陷阱",
  "role.INFORMATIONAL": "信息性",
  "role.REFERENCE": "参考",
  "role.OPTIONAL_EXTENSION": "可选",
  "priority.1": "必学",
  "priority.2": "重要",
  "priority.3": "拓展",
  "label.page": "第 {n} 页",
  "label.pages": "第 {a}–{b} 页",
  "label.pageShort": "第{n}页",
  "label.pagesShort": "第{a}–{b}页",
  "category.law": "法律",
  "category.economics_business": "经济与商业",
  "category.accounting_finance": "会计与金融",
  "category.medicine_health": "医学与健康",
  "category.sciences": "自然科学",
  "category.mathematics": "数学",
  "category.engineering": "工程",
  "category.computer_science": "计算机科学",
  "category.languages": "语言",
  "category.humanities": "历史与人文",
  "category.arts": "艺术与音乐",
  "category.professional_exams": "职业考试",
  "category.other": "其他",
  "level.all": "所有级别",
  "level.beginner": "初级",
  "level.intermediate": "中级",
  "level.advanced": "高级",
  "size.small": "简短（少于 50 题）",
  "size.medium": "中等（50–299 题）",
  "size.large": "大型（300 题以上）",
  "sort.popular": "最受欢迎",
  "sort.newest": "最新",
  "sort.largest": "题目最多",
  "lang.it": "意大利语",
  "lang.en": "英语",
  "price.free": "免费",
  "common.loading": "加载中…",
  "common.tryAgain": "重试",
  "common.dismiss": "关闭",
  "common.delete": "删除",
  "common.edit": "编辑",
  "common.rename": "重命名",
  "common.title": "标题",
  "common.description": "描述",
  "common.continue": "继续",
  "common.search": "搜索",
  "common.add": "添加",
  "common.remove": "移除",
  "common.yes": "是",
  "common.no": "否",
  "common.collapse": "折叠 {label}",
  "common.expand": "展开 {label}",
  "drag.item": "项目",
  "drag.reorder": "调整 {label} 的顺序",
  "drag.pickedUp": "已选中 {label}，第 {pos} 位，共 {total} 项。",
  "drag.over": "{label} 现在在第 {pos} 位，共 {total} 项。",
  "drag.dropped": "{label} 已放在第 {pos} 位，共 {total} 项。",
  "drag.droppedPlain": "已放下 {label}。",
  "drag.cancelled": "已取消移动 {label}。",
  "drawing.loadFailed": "无法加载绘图。",
  "course.authorOrder": "此课程的顺序由作者决定。",
  "priority.yours": "你的优先级",
  "priority.label": "优先级",
  "priority.author": "作者：{name}",
  "priority.useAuthor": "使用作者的设置",
  "editTitle.rename": "重命名{label}",
  "label.course": "课程",
  "label.chapter": "章节",
  "label.topic": "主题",
  "label.concept": "概念",
  "library.heading": "我的课程",
  "library.count.one": "{n} 门课程",
  "library.count.other": "{n} 门课程",
  "library.shownOf": "显示 {shown} / {total}",
  "library.search": "搜索课程",
  "library.show": "显示",
  "library.sortBy": "排序方式",
  "library.new": "+ 新建课程",
  "library.marketplace": "🛒 课程市场",
  "library.empty": "还没有课程。创建一门课程，然后添加你的学习资料或自己的问答。",
  "library.createFirst": "创建你的第一门课程",
  "library.noMatch": "没有符合此搜索或筛选的课程。",
  "libStatus.all": "全部课程",
  "libStatus.in_progress": "进行中",
  "libStatus.not_started": "未开始",
  "libStatus.due": "待复习",
  "libStatus.completed": "没有新内容可学",
  "libStatus.paused": "已暂停",
  "libStatus.archived": "已归档",
  "libSort.recent_study": "最近学习",
  "libSort.recent_created": "最近创建",
  "libSort.alphabetical": "按字母",
  "libSort.most_due": "待复习最多",
  "card.marketplacePill": "🛒 来自课程市场 · 作者 {author}",
  "card.marketplaceHint": "作者会持续更新内容；学习进度属于你自己。",
  "card.continue": "继续",
  "card.next": "下一个",
  "card.archived": "已归档",
  "card.paused": "已暂停",
  "card.conceptsStudied": "个概念已学习",
  "card.itemsIntroduced": "个学习项已引入",
  "card.moreFor": "{title} 的更多操作",
  "menu.details": "课程详情",
  "menu.material": "学习资料",
  "menu.progress": "进度",
  "menu.publish": "🛒 发布到课程市场",
  "menu.pause": "暂停",
  "menu.resume": "恢复",
  "menu.archive": "归档",
  "menu.restore": "恢复",
  "menu.delete": "删除…",
  "menu.confirmOwn": "要删除“{title}”吗？它的章节、题目、资料和你的答案会被永久删除。如想保留全部内容，请改为归档。",
  "menu.confirmMarketplace": "要删除“{title}”吗？你可以免费从课程市场重新添加。",
  "newCourse.aria": "新建课程",
  "newCourse.language": "资料语言",
  "newCourse.create": "创建课程",
  "learn.resume.label": "继续练习",
  "learn.resume.hint": "继续未完成的这一轮",
  "learn.study.label": "学习下一个",
  "learn.study.hint": "学习 {title}",
  "learn.study.hintNone": "学习新资料",
  "learn.activate.label": "开始学习",
  "learn.activate.hint": "准备 {title} 的题目并开始学习",
  "learn.activate.hintNone": "开始学习下一个概念",
  "learn.setup.label": "添加资料",
  "learn.setup.hint": "添加学习资料或你自己的题目即可开始",
  "learn.none.label": "全部学完 ✓",
  "learn.none.hint": "此课程的所有内容都已学完",
  "review.none": "✓ 现在没有要复习的",
  "review.noneTitle": "此课程目前没有需要复习的内容",
  "review.aria.one": "复习 {n} 项",
  "review.aria.other": "复习 {n} 项",
  "review.button": "复习",
  "course.practiceHard": "练习难题",
  "course.chapters": "章节",
  "course.chaptersEmpty": "先添加一个章节，再往里添加学习资料。",
  "course.chapterMeta": "{total} 个概念中 {active} 个进行中 · 掌握度 {mastery}",
  "course.newChapter": "新章节标题",
  "course.addChapter": "添加章节",
  "course.curriculum": "课程大纲",
  "course.fallback": "课程",
  "course.allMaterial": "全部学习资料",
  "course.manageQuestions": "管理题目",
  "course.weakSpots": "你总是答错的内容",
  "chapter.gone": "该章节已不存在。",
  "chapter.topics": "主题",
  "chapter.starting": "正在开始分析…",
  "chapter.analyze": "分析新资料",
  "chapter.analyzeHint": "AI 会根据尚未分析的资料提出主题和概念。在任何内容更改之前，你会先审阅提案。",
  "chapter.noMaterial": "此章节没有需要分析的新资料。请先上传资料。",
  "chapter.empty": "还没有主题。请在下方上传资料，然后进行分析。",
  "chapter.topicMeta": "{total} 个概念中 {active} 个进行中",
  "topic.gone": "该主题已不存在。",
  "topic.concepts": "概念",
  "topic.empty": "该主题中没有概念。",
  "topic.needsReview": "需要检查来源",
  "topic.conceptMeta": "{state} · 掌握度 {mastery}",
  "unit.item.one": "{n} 项",
  "unit.item.other": "{n} 项",
  "unit.answer.one": "{n} 个回答",
  "unit.answer.other": "{n} 个回答",
  "consolidate.continue": "继续巩固",
  "consolidate.unfinished": "你的 {items} 一组尚未完成:还剩 {left}。已作的回答会保留。",
  "consolidate.resume": "继续",
  "consolidate.doneTitle": "已巩固",
  "consolidate.doneBody": "此概念的每个项目都完成了巩固轮次，到期时会回到你的复习中。",
  "consolidate.title": "学完这个概念了吗？",
  "consolidate.body": "请先阅读上方要学习的内容。准备好后,每个问题会一直重复,直到你答对 {n} 次(不必连续),每次回答后都有反馈。",
  "consolidate.batch": "本批：{items} · {answers}",
  "consolidate.more.one": "还有 {n} 项等待之后的批次",
  "consolidate.more.other": "还有 {n} 项等待之后的批次",
  "consolidate.button": "我已学完这个概念",
  "breadcrumb.aria": "路径导航",
  "dash.title": "仪表板",
  "dash.loading": "正在加载仪表板…",
  "dash.aside": "你的学习",
  "dash.today": "今天",
  "dash.xpTodayPlus": "今天 +{n} 经验值",
  "dash.goal": "目标 {done}/{target}",
  "dash.tzNote": "你的学习日（连续天数、目标、今日经验值）按 {zone} 计算。此设备位于 {device}。",
  "dash.tzUse": "使用 {zone}",
  "next.title": "你的下一步",
  "next.resumeTitle": "继续巩固 · 第 {round} 次答对,共需 {total} 次",
  "next.answersLeft": "还剩 {n} 个回答",
  "next.resume": "继续",
  "next.minutes": "约 {n} 分钟",
  "next.startReview": "开始复习",
  "next.learnTitle": "继续学习：{concept}",
  "next.nextConcept": "下一个概念",
  "next.learn": "学习",
  "next.setupTitle": "设置 {concept}",
  "next.theNextConcept": "下一个概念",
  "next.setupDetail": "{course} · 激活它以准备题目",
  "next.setup": "设置",
  "next.addMaterialTitle": "向 {course} 添加资料",
  "next.yourCourse": "你的课程",
  "next.addMaterialDetail": "上传学习资料或你自己的问答，以构建其概念。",
  "next.firstCourse": "开始你的第一门课程",
  "next.firstCourseDetail": "创建一门课程，然后添加资料或你自己的题目。",
  "next.caughtUp": "你已全部完成",
  "next.caughtUpDetail": "没有到期内容，也没有等待学习的新资料。",
  "streak.title": "每日连续",
  "streak.unit.one": "天",
  "streak.unit.other": "天",
  "streak.done": "今天已完成。明天再来继续保持。",
  "streak.keep": "今天回答一道题即可保持连续记录。",
  "streak.start": "今天回答一道题即可开始连续记录。",
  "streak.last7": "最近 7 天",
  "streak.studied": "已学习",
  "streak.noStudy": "未学习",
  "xp.title": "经验值",
  "xp.how": "经验值如何运作",
  "xp.howBody": "对同一学习项每答对一次，奖励会递增：第一次 10 经验值，然后 20、30……最高 150。使用提示会让该回答的经验值减半。答错不得分，但不会重置你的进度。经验值奖励练习，永远不会改变你的复习计划。",
  "goal.title": "每日目标",
  "goal.sr": "每日目标：今天已完成 {done}/{target} 个回答，{percent}%。",
  "goal.answersToday": "今天 {done} / {target} 个回答",
  "goal.perDay": "每天回答数",
  "goal.edit": "修改目标",
  "goal.invalid": "请选择 1 到 500 之间的整数。",
  "planner.title": "时间规划",
  "planner.now": "现在",
  "planner.1h": "1 小时内",
  "planner.4h": "4 小时内",
  "planner.1d": "1 天内",
  "planner.3d": "3 天内",
  "planner.7d": "7 天内",
  "planner.dueNow": "现在有 {n} 项到期：约 {min} 分钟",
  "planner.caption": "各时间点前到期的复习，包括已逾期的",
  "planner.dueBy": "到期时间",
  "planner.items": "项目",
  "planner.hint": "基于你当前的复习计划，会随学习而变化。每一行包含此前所有到期的内容。",
  "activity.title": "活动",
  "activity.seeMore": "查看更多",
  "activity.future": "{day}：未来",
  "activity.day": "{day}：{answers}",
  "activity.dayXp": "{day}：{answers}，{xp} 经验值",
  "activity.aria": "活动日历：{days}，{answers}",
  "activity.summary": "{days} · {answers}",
  "unit.activeDay.one": "{n} 个活跃日",
  "unit.activeDay.other": "{n} 个活跃日",
  "activity.less": "少",
  "activity.more": "多",
  "activity.legendFuture": "未来",
  "pb.curriculumHint": "你已学习并激活了多少资料。",
  "pb.conceptsActive": "进行中的概念",
  "pb.activeOf": "{active} / {total}",
  "pb.memory": "记忆",
  "pb.memoryHint": "你对所练内容的记忆程度。掌握度是根据复习得出的估算。",
  "pb.mastery": "掌握度（估算）",
  "pb.itemsTrained": "训练中的项目",
  "pb.markedHard": "标记为困难",
  "pb.dueNow": "现在到期",
  "pb.laterToday": "今天晚些时候",
  "pb.tomorrow": "明天",
  "pb.next7": "未来 7 天",
  "pb.newToLearn": "待学新内容",
  "pb.overdue.one": "有 {n} 道题已逾期：请先做这些。",
  "pb.overdue.other": "有 {n} 道题已逾期：请先做这些。",
  "pb.caption": "此课程即将到期的题目及大致所需时间",
  "pb.when": "时间",
  "pb.questions": "题目",
  "pb.time": "耗时",
  "pb.minutes": "约 {n} 分钟",
  "study.intent.LEARN": "学习",
  "study.intent.SCHEDULED_REVIEW": "复习",
  "study.intent.PRACTICE": "练习",
  "study.intent.EXAM": "考试",
  "study.intent.CONSOLIDATION": "巩固",
  "study.round": "第 {n} 次答对,共需 {total} 次",
  "study.progressAria": "本次学习进度",
  "study.progress": "{n} / {total}",
  "study.xpSessionAria": "本次 {n} 经验值",
  "study.ownReview": "自主复习：不改变计划，没有经验值",
  "study.leaveResume": "离开（稍后继续）",
  "study.end": "结束本次学习",
  "study.preparing": "正在准备学习…",
  "study.empty.title": "现在没有可学的内容",
  "study.empty.body": "没有符合本次学习的内容。请激活一个概念以添加新资料，或在复习到期时再来。",
  "study.empty.back": "返回课程",
  "study.newMaterial": "新资料",
  "study.keyPoints": "要点",
  "study.sources": "来源",
  "study.ready": "我准备好了：来考我",
  "study.answering": "作答",
  "study.drawHint": "请在下方画出你的答案，AI 会将它与参考图比较。",
  "study.note": "备注（可选）",
  "study.yourAnswer": "你的回答",
  "study.notePlaceholder": "想为图画补充点什么…",
  "study.answerPlaceholder": "用你自己的话回答…",
  "study.stopListening": "停止收听",
  "study.speak": "口述你的回答",
  "study.evaluating": "正在评估…",
  "study.submit": "提交",
  "study.skip": "跳过此题",
  "study.dictationOn": "听写由你的浏览器转写，浏览器可能会把音频发送到其语音服务。只会保留文字，提交前可以修改。",
  "study.dictationOff": "语音回答需要 Chrome、Edge 或 Safari。你也可以在这里输入答案。",
  "study.drawingCompare": "你的绘图与参考图",
  "study.yourDrawing": "你的绘图",
  "study.reference": "参考",
  "study.gradedByYou": "由你评分",
  "study.needsGrade": "需要你来评分",
  "study.firstEval": "首次评估",
  "study.secondOpinion": "第二意见",
  "study.afterObjection": "针对你的异议：“{text}”",
  "study.referenceSummary": "参考答案与来源",
  "study.studyConcept": "📖 学习这个概念",
  "study.gradeHow": "你对它掌握得如何？",
  "study.gradeYourself": "或者由你自己评分",
  "study.yourGrade": "你的评分",
  "study.retryEval": "重新评估",
  "study.skipNow": "暂时跳过",
  "study.disagree": "不同意这个评分？",
  "study.notMemorized": "尚未记住：本次学习中会再次出现。",
  "study.levelNext": "等级 {from} → {to}。下次复习：{when}",
  "study.practiceNote": "练习不会改变你的复习计划。",
  "study.complete": "学习完成",
  "study.xpSessionPlus": "本次 +{n} 经验值",
  "study.answeredIn": "{answers}，约 {min} 分钟。",
  "study.wentWell": "{n} 个回答不错。",
  "study.steady": "稳扎稳打：正在逐渐记牢。",
  "study.comeBack": "没答好的很快会再出现，这样才能记牢。",
  "study.stillDue": "现在仍到期：{n} 项（约 {min} 分钟）。",
  "study.nothingDue": "现在没有其他到期内容。",
  "study.done": "完成",
  "study.noXp": "此回答不获得经验值（练习，或尚未到复习时间）。",
  "study.correctXp": "答对：+{n} 经验值",
  "study.halfXp": "（使用了提示：经验值减半）",
  "study.hintLabel": "提示",
  "study.noHint": "此题没有提示。",
  "study.showHint": "显示提示",
  "study.hintHalves": "使用提示会让这次回答的经验值减半。",
  "study.revealHint": "揭示提示",
  "study.plusZero": "+0 经验值",
  "study.onlyCorrectSelf": "只有答对才有经验值：你自己评的“困难”“良好”“简单”同样算数。",
  "study.onlyCorrect": "只有完全答对才有经验值。你离下一次奖励的进度会被保留。",
  "study.awardCorrect": "正确",
  "study.awardHint": "使用了提示",
  "study.ordinal": "此项目第 {n} 次答对",
  "study.ordinalHalf": "此项目第 {n} 次答对，为 {base} 的一半",
  "study.batchDone": "这一批已巩固",
  "study.correctAnswers": "答对数",
  "study.xpThisSession": "本次经验值",
  "study.whatNext": "接下来会怎样",
  "study.whatNextBody": "最后一轮答对的项目大约 4 小时后回到复习中；其余的等待下一批。",
  "study.waiting.one": "还有 {n} 项在等待",
  "study.waiting.other": "还有 {n} 项在等待",
  "study.batchNotAll": "这一批已完成，但整个概念还没有：{waiting}。",
  "study.allRounds": "此概念中所有待处理的条目都已答对三次。",
  "study.nextBatch": "下一批",
  "study.conceptCosts": "现在查看概念相当于使用提示：这次回答的经验值减半。",
  "study.openConcept": "打开概念",
  "study.dontRemember": "📖 想不起来？学习这个概念",
  "study.refDrawing": "参考图",
  "dispute.title": "请 AI 再看一遍",
  "dispute.testAi": "测试 AI 无法读取你的异议：第二意见只会给出相同评分。请在下方自己评分。",
  "dispute.why": "你为什么不同意？",
  "dispute.placeholder": "说说评估哪里不对…",
  "dispute.hint": "AI 会看到你的异议并重新评估。两种意见都会保留；只有你在下方选择后评分才会改变。",
  "dispute.asking": "正在询问…",
  "dispute.ask": "请求第二意见",
  "eval.correct": "正确",
  "eval.complete": "完整",
  "eval.understanding": "理解",
  "eval.precise": "精确",
  "eval.Strong": "优秀",
  "eval.Partial": "部分",
  "eval.Weak": "较弱",
  "eval.scoreBreakdown": "评分明细",
  "eval.right": "正确",
  "eval.missing": "缺失",
  "eval.misconception": "概念错误",
  "eval.materialSays": "资料中写道",
  "eval.covered": "你的回答涵盖了什么",
  "eval.failed": "无法评估该回答。",
  "eval.aiEvaluation": "AI 评估：{verdict}",
  "eval.insufficient": "课程资料对此覆盖不足，无法评分。",
  "eval.testAiTitle": "测试 AI。",
  "eval.testAiBody": "此评分来自一个只会逐词对比参考答案的替代程序：它无法理解改写或异议。请查看参考答案并自己评分，或接入真正的 AI。",
  "conceptPanel.title": "学习这个概念",
  "conceptPanel.next": "学完了 — 下一题",
  "conceptPanel.closeAria": "关闭概念",
  "conceptPanel.loading": "正在加载概念…",
  "conceptPanel.openFull": "在新标签页中打开完整的概念页面",
  "dictation.blocked": "麦克风被阻止。请在浏览器的网站设置中允许后再听写。",
  "dictation.network": "语音识别需要网络连接。",
  "dictation.noMic": "未找到麦克风。",
  "dictation.stopped": "语音识别意外停止。你可以继续输入。",
  "concept.activate": "激活",
  "concept.activateHelp": "根据你的资料准备此概念的题目，方便你学习。",
  "concept.markStudied": "标记为已学习",
  "concept.markStudiedHelp": "你在别处学过：仅作记录，暂不准备题目。",
  "concept.activateAgainHelp": "重新学习：其题目会回到你的学习中。",
  "concept.pause": "暂停",
  "concept.pauseHelp": "暂时停止其题目，不会丢失任何内容。",
  "concept.deactivate": "停用",
  "concept.deactivateHelp": "将其移出学习和复习。你的回答和历史会保留。",
  "concept.resume": "恢复",
  "concept.resumeHelp": "让其题目回到学习和复习中。",
  "concept.sourceDeleted": "此概念所依据的资料已被删除。请保留、编辑或删除它。",
  "concept.manage": "管理此概念",
  "concept.loadingItems": "正在加载学习项…",
  "concept.preparing": "正在准备学习项…",
  "concept.itemsFailed": "无法准备学习项。",
  "concept.noSource": "此概念没有可用来生成学习项的资料。",
  "concept.whatToStudy": "要学习的内容",
  "concept.reviewOwnHelp": "随时可以就此概念接受测试。这不会改变你的复习计划，也没有经验值。",
  "concept.reviewOwn": "🔁 自主复习",
  "concept.readThen": "先阅读这些内容，然后点击下方的“我已学完这个概念”来练习。",
  "concept.testMe": "🔁 就此考我",
  "concept.hideDetails": "隐藏详情",
  "concept.details": "详情",
  "concept.level": "等级 {n}",
  "concept.markedHard": "已标记为困难",
  "concept.notTraining": "未在训练中",
  "concept.state": "状态",
  "concept.levelLabel": "等级",
  "concept.nextReview": "下次复习",
  "concept.reviews": "复习次数",
  "concept.lapses": "遗忘次数",
  "concept.inTraining": "训练中",
  "concept.questions": "题目",
  "concept.sourcesTitle": "来源",
  "concept.loadingSources": "正在加载来源…",
  "concept.noSources": "没有来源段落。",
  "concept.misconceptions": "反复出现的概念错误",
  "drawing.answerBy": "用绘图作答",
  "drawing.studentsDraw": "学生通过绘图回答此题，AI 会将他们的绘图与此图比较。",
  "drawing.youDraw": "你通过绘图回答此题，AI 会将你的绘图与此图比较。",
  "drawing.referenceAlt": "参考图",
  "drawing.explain": "对于用绘图作答的题目（分子、示意图、图表）：添加正确的图，学生就会用画图代替文字作答。",
  "drawing.save": "保存此绘图",
  "drawing.replace": "用图片替换…",
  "drawing.upload": "上传绘图…",
  "drawing.drawNew": "重新绘制",
  "drawing.drawHere": "在此绘制",
  "drawing.words": "改用文字作答",
  "drawing.tools": "绘图工具",
  "drawing.pen": "✏️ 画笔",
  "drawing.eraser": "🧽 橡皮擦",
  "drawing.thick": "粗线",
  "drawing.thin": "细线",
  "drawing.undo": "↶ 撤销",
  "drawing.clear": "清除",
  "drawing.area": "绘图区域：在这里画出你的答案",
  "drawing.photoUpload": "画在纸上了？改为上传照片",
  "drawing.photoError": "该文件不是此浏览器能读取的图片。请尝试 JPEG 或 PNG 照片。",
  "drawing.photoAlt": "你拍摄的绘图照片",
  "drawing.drawInstead": "改为绘制",
  "q.title": "题目",
  "q.introOwn": "选择题目即可删除、暂停、恢复或移动；拖动 ⠿ 调整顺序；编辑某道题可修正标题、措辞或预期答案。",
  "q.introManaged": "此课程来自课程市场：作者会持续更新题目。选择题目即可暂停或恢复，也可以设置你自己的优先级（只有你能看到）。",
  "q.search": "搜索题目",
  "q.searchPlaceholder": "搜索题目和答案",
  "q.allPriorities": "所有优先级",
  "q.priorityOnly": "仅{label}（{n}）",
  "q.deselectAll": "取消全选",
  "q.selectAll": "全选（{n}）",
  "q.selectAllShown": "选择当前显示的全部（{n}）",
  "q.collapseAll": "全部折叠",
  "q.expandAll": "全部展开",
  "q.selectedAria": "已选题目",
  "q.selectedCount": "已选 {n} 项",
  "q.moveTo": "移动到…",
  "q.setPriority": "设置优先级",
  "q.setPriorityPlaceholder": "设置优先级…",
  "q.reviewSelectedHelp": "立即就所选题目接受测试。这不会改变你的复习计划，也没有经验值。",
  "q.clearSelection": "清除选择",
  "q.verb.delete": "已删除",
  "q.verb.pause": "已暂停",
  "q.verb.resume": "已恢复",
  "q.verb.move": "已移动",
  "q.verb.set_priority": "已更新",
  "unit.question.one": "{n} 道题",
  "unit.question.other": "{n} 道题",
  "unit.chapter.one": "{n} 个章节",
  "unit.chapter.other": "{n} 个章节",
  "unit.topic.one": "{n} 个主题",
  "unit.topic.other": "{n} 个主题",
  "unit.concept.one": "{n} 个概念",
  "unit.concept.other": "{n} 个概念",
  "unit.group.one": "{n} 个已清空的分组",
  "unit.group.other": "{n} 个已清空的分组",
  "q.newConcepts.one": "新增 {n} 个概念",
  "q.newConcepts.other": "新增 {n} 个概念",
  "q.removedConcepts.one": "已移除 {n} 个空概念",
  "q.removedConcepts.other": "已移除 {n} 个空概念",
  "q.noticeBulk": "{verb} {questions}{extra}。",
  "q.noticeDeleted": "已删除 {questions}。",
  "q.noticeDeletedGroups": "已删除 {questions} 和 {groups}。",
  "q.confirmDelete": "要删除 {questions} 吗？它们的回答和复习记录也会一并删除。{also}",
  "q.confirmAlso": "  没有题目的 {groups} 也会一并删除。",
  "q.emptySearch": "没有符合此搜索的题目。",
  "q.empty": "还没有题目。请激活一个概念，或导入你自己的问答。",
  "q.clearToReorder": "清除搜索后才能调整这些题目的顺序。",
  "q.select": "选择：{text}",
  "q.otherWordings.one": "另有 {n} 种措辞",
  "q.otherWordings.other": "另有 {n} 种措辞",
  "q.editAria": "编辑题目",
  "q.titleLabel": "标题（在列表中显示）",
  "q.wordings": "题目措辞",
  "q.wording": "措辞 {n}",
  "q.addWording": "+ 再添加一种措辞",
  "q.expected": "预期答案",
  "q.prio1": "必学：核心内容，必须掌握",
  "q.prio2": "重要：应当掌握",
  "q.prio3": "拓展：补充内容，更深入的细节",
  "q.keyPoints": "要点（每行一个，最多 10 个）",
  "q.moveAria": "移动题目",
  "q.moveHeading": "将 {questions} 移动到",
  "q.choose": "选择主题或概念…",
  "q.topicOption": "主题：{title}（每道题保留自己的概念）",
  "q.conceptOption": "   ↳ 放入概念：{title}",
  "q.removeEmpty": "移除没有题目的概念",
  "q.moveHint": "题目会保留复习进度。在未激活的概念中，激活之前不会被复习。",
  "q.move": "移动",
  "q.groupSelect": "选择 {label} 中的所有题目",
  "mat.chapterTitle": "章节资料",
  "mat.collapseLabel": "学习资料",
  "mat.files.one": "{n} 个文件",
  "mat.files.other": "{n} 个文件",
  "mat.uploading": "正在上传…",
  "mat.upload": "上传资料",
  "mat.uploadQa": "上传问答",
  "mat.paste": "粘贴文本",
  "mat.howTo": "如何准备问答",
  "mat.howToBody": "上传 PDF、Word、文本或 Markdown 文件，每道题在行首以“Domanda:”开头、预期答案以“Risposta:”开头（或“Question:” / “Answer:”）。标题会把题目归入不同主题。",
  "mat.howToBody2": "每道题都会成为一个标记为未学习的概念，你的答案即为预期答案。激活后即可开始复习。导入过程不使用 AI。",
  "mat.loading": "正在加载资料…",
  "mat.none": "还没有资料。请上传 PDF、Word、PowerPoint、文本或 Markdown 文件。",
  "mat.file": "文件",
  "mat.status": "状态",
  "mat.passages": "段落",
  "mat.added": "添加时间",
  "mat.actions": "操作",
  "mat.qa": "问答",
  "mat.processing": "处理中…",
  "mat.ready": "就绪",
  "mat.failed": "失败",
  "mat.download": "下载",
  "mat.confirmDelete": "要删除 {name} 吗？由它生成的概念会被标记为需要检查。",
  "mat.pasteAria": "粘贴文本",
  "mat.pastePlaceholder": "例如：第 3 课笔记",
  "mat.thisTextIs": "此文本是",
  "mat.asMaterial": "学习资料",
  "mat.asQa": "问答（Domanda: / Risposta:）",
  "mat.text": "文本",
  "mat.textPlaceholderQa": "# 主题\nDomanda: …?\nRisposta: …",
  "mat.textPlaceholder": "# 标题\n你的笔记…",
  "mat.adding": "正在添加…",
  "mat.addText": "添加文本",
  "mat.pastedName": "粘贴的文本 {when}",
  "prop.title": "建议的课程大纲",
  "prop.reading": "AI 正在阅读你的资料…",
  "prop.applied": "此提案已被应用。",
  "prop.failed": "AI 无法提出课程大纲。",
  "prop.blank": "每个章节、主题和概念都需要标题。",
  "prop.longMaterial": "资料较长：这里只涵盖前 {used} 个段落，共 {total} 个。",
  "prop.dropped": "有 {n} 个提议的概念因无法与你的资料对应而被省略。",
  "prop.hint": "可以编辑下面的任何内容：重命名、调整顺序、在主题间移动概念、合并、删除或添加。不会激活任何内容：之后由你选择要学什么。",
  "prop.chapterTitle": "章节标题",
  "prop.deleteChapter": "删除章节",
  "prop.accept": "接受课程大纲",
  "prop.reject": "拒绝提案",
  "prop.topicAria": "主题 {title}",
  "prop.existingTopic": "已有主题",
  "prop.topicTitle": "主题标题",
  "prop.moveTopicUp": "上移主题",
  "prop.moveTopicDown": "下移主题",
  "prop.deleteTopic": "删除主题",
  "prop.conceptTitle": "概念标题",
  "prop.exists": "已存在",
  "prop.moveConceptUp": "上移概念",
  "prop.moveConceptDown": "下移概念",
  "prop.moveToTopic": "移到主题",
  "prop.untitled": "未命名主题",
  "prop.merge": "与下一个合并",
  "prop.addConcept": "+ 添加概念",
  "mkt.intro": "其他 LEARNABLE 用户创建的课程。把一门课程添加到你的课程中，按你自己的计划学习：作者会持续更新。要分享你自己的课程，请打开它并填写它的“课程市场页面”。",
  "mkt.categories": "类别",
  "mkt.all": "全部",
  "mkt.searchPlaceholder": "按标题或描述搜索",
  "mkt.level": "难度",
  "mkt.language": "语言",
  "mkt.size": "规模",
  "mkt.sort": "排序",
  "mkt.any": "不限",
  "mkt.loading": "正在加载课程…",
  "mkt.noMatch": "暂时没有符合这些筛选条件的课程。",
  "mkt.publishedByMe": "我发布的",
  "mkt.status.DRAFT": "草稿",
  "mkt.status.PUBLISHED": "已发布",
  "mkt.status.UNPUBLISHED": "未发布",
  "mkt.version": "版本 {n}",
  "mkt.students.one": "{n} 位学习者",
  "mkt.students.other": "{n} 位学习者",
  "mkt.editCourse": "编辑课程及其页面",
  "mkt.by": "作者 {author}",
  "mkt.inYourCourses": "在你的课程中",
  "mkt.loadingCourse": "正在加载课程…",
  "mkt.updated": "更新于 {date}",
  "mkt.statStudents": "学习者",
  "mkt.yourCourse": "你的课程",
  "mkt.draftTag": "草稿",
  "mkt.notPublishedTag": "未发布",
  "mkt.open": "在我的课程中打开",
  "mkt.addBack": "重新添加到我的课程",
  "mkt.add": "添加到我的课程 · {price}",
  "mkt.about": "关于此课程",
  "mkt.learn": "你将学到什么",
  "mkt.audience": "适合人群",
  "mkt.hiddenNote": "课程添加到你的课程后，才能看到题目和答案。你在 LEARNABLE 内学习它们：作者的资料无法下载。",
  "sales.originTitle": "🛒 来自课程市场",
  "sales.madeBy": "作者：{author}（版本 {version}）。作者会持续更新章节、题目和答案，因此你无法在此编辑：更新会自动同步给你。",
  "sales.yourStudy": "学习由你自己掌控：激活概念、暂停、你的回答、你的复习计划和经验值，以及你为每道题设置的优先级（只有你能看到）。",
  "sales.seePage": "查看其课程市场页面",
  "sales.title": "🛒 课程市场页面",
  "sales.pPublished": "已发布 · 版本 {n}",
  "sales.pNot": "未发布",
  "sales.pDraft": "草稿",
  "sales.pNone": "未分享",
  "sales.explain": "与其他用户分享这门课程。在这里编写它的页面，这是别人添加之前唯一能看到的内容：涵盖什么、适合谁、能学到什么。他们还能看到章节标题和题目数量；题目本身只有在添加之后才能看到，而你上传的资料永远不会被看到。",
  "sales.seeAsOthers": "查看他人所见的样子",
  "sales.edit": "编辑课程市场页面",
  "sales.write": "编写课程市场页面",
  "sales.subtitle": "副标题",
  "sales.subtitleHint": "（一行，例如“口试全部 300 道题，附标准答案”）",
  "sales.category": "类别",
  "sales.description": "描述",
  "sales.descriptionHint": "（涵盖内容、制作方式、使用方法）",
  "sales.outcomes": "学生将学到什么",
  "sales.outcomesHint": "（每行一个，最多 8 个）",
  "sales.tags": "标签",
  "sales.tagsHint": "（用逗号分隔，最多 8 个）",
  "sales.saveDraft": "保存草稿",
  "sales.savePage": "保存页面",
  "sales.publish": "发布",
  "sales.publishUpdate": "发布更新",
  "sales.publishHintUpdate": "把你当前的章节、题目和答案发送给所有拥有该课程的人。他们自己的进度会保留。",
  "sales.publishHint": "让课程在课程市场中可见。目前免费。你可以继续编辑，之后再发布更新。",
  "sales.rights": "这些题目和答案由我分享（是我编写的，或我拥有其来源资料的权利）。",
  "sales.publishing": "正在发布…",
  "sales.publishUpdateBtn": "发布更新",
  "sales.unpublish": "取消发布",
  "sales.noteSaved": "已保存：课程市场页面现已显示。",
  "sales.noteDraft": "草稿已保存。发布之前其他人看不到。",
  "sales.notePublishedV": "已发布版本 {n}：所有拥有该课程的人现在都会收到你的最新题目。",
  "sales.notePublished": "已发布！其他用户现在可以在课程市场中找到它。",
  "sales.noteUnpublished": "已取消发布：新用户找不到它。已拥有的人仍可继续使用。",
  "prog.empty": "创建一门课程并开始学习，就能看到你的进度。",
  "prog.weakConcepts": "薄弱概念",
  "prog.weakMeta": "遗忘次数：{lapses} · 标记为困难：{hard}",
  "prog.byChapter": "按章节和主题",
  "prog.colChapter": "章节 / 主题",
  "weak.intro": "在你近期回答中发现的错误，按概念分组。当你对该项目的最新回答不再出现这些错误时，它们就会消失。练习不会改变你的复习计划。",
  "weak.loading": "正在查看你最近的回答…",
  "weak.empty": "目前没有反复出现的错误。继续回答，它们会出现在这里。",
  "weak.practiceTop.one": "练习最需要的 {n} 个概念",
  "weak.practiceTop.other": "练习最需要的 {n} 个概念",
  "weak.practiceThis": "练习这个",
  "weak.seen.one": "出现 {n} 次，最近一次 {date}",
  "weak.seen.other": "出现 {n} 次，最近一次 {date}",
  "home.intro": "按计划复习能巩固你学过的内容。到期数量与复习环节使用相同的规则。",
  "home.noCourses": "还没有课程。",
  "home.createOnDashboard": "在你的仪表板上创建一个",
  "home.meta": "现在有 {due} 项到期 · 已引入 {trained} 项中的 {introduced} 项",
  "activity.pageIntro": "过去一年中每天完成的回答数（按你的时区）。回答一旦有了最终评分就会计入，无论对错。",
  "reset.title": "重置密码",
  "reset.intro": "输入你的账号邮箱。我们会发送一个用于设置新密码的链接；链接只能使用一次，有效期 30 分钟。",
  "reset.send": "发送重置链接",
  "reset.sentMessage": "如果此邮箱对应有账号，重置密码的链接已在发送途中。请查看收件箱（以及垃圾邮件）。",
  "reset.back": "返回登录",
  "reset.chooseTitle": "设置新密码",
  "reset.incomplete": "此链接不完整。请重新打开邮件中的链接，或申请新的链接。",
  "reset.done": "你的密码已更改。所有设备都已退出登录：请使用新密码登录。",
  "reset.newPassword": "新密码",
  "reset.repeat": "重复新密码",
  "reset.tooShort": "请至少使用 {n} 个字符。",
  "reset.mismatch": "两次输入的密码不一致。",
  "reset.set": "设置新密码",
  "source.aria": "来源段落",
  "source.closeAria": "关闭来源",
  "source.loading": "正在加载段落…",
  "source.open": "打开来源段落",
  "course.loadingCurriculum": "正在加载课程大纲…",
  "mkt.addPlain": "添加到我的课程",
  "sales.pageName": "课程市场页面",
};
